const chunkMapping = {
	"460": [
		37460
	],
	"610": [
		78610
	],
	"994": [
		85994
	]
};
const idToExternalAndNameMapping = {
	"37460": [
		"default",
		"./Omni",
		40003
	],
	"78610": [
		"default",
		"./TrackGuard",
		72216
	],
	"85994": [
		"default",
		"./ChatExperience",
		99550
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}